import styles from './styles/Home.module.css';

const Home = () => (
  <>
    <div className={styles.home}>
      <h2 className={styles.title}>
        Welcome to our page!
      </h2>
      <p>
        Lorem ipsum dolor sit amet consectetur adipisicing elit.
        Eaque eius in repudiandae aspernatur amet magni molestiae
        earum distinctio dolores officia, accusantium expedita,
        ipsum ea mollitia a aperiam eos illo fugit?
      </p>
      <p>
        Lorem ipsum dolor sit amet consectetur adipisicing elit.
        Eaque eius in repudiandae aspernatur amet magni molestiae
        earum distinctio dolores officia, accusantium expedita,
        ipsum ea mollitia a aperiam eos illo fugit?
      </p>
    </div>
  </>
);

export default Home;
